import { FOOD_TAG_NAME } from '../../../../constants/foodTagName';
import { FoodTag } from '../../../../interfaces/FoodTag';

const isSupplementTag = ({ name }: FoodTag) => name === FOOD_TAG_NAME.SUPPLEMENT;

/** a new supplement starts with the "Supplement" tag, when the dictionary has one */
export const withSupplementTag = (selectedTags: FoodTag[], allTags: FoodTag[]) => {
  const supplementTag = allTags.find(isSupplementTag);

  return supplementTag && !selectedTags.some(isSupplementTag)
    ? [...selectedTags, supplementTag]
    : selectedTags;
};
